// @flow
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { getTypeName, getSerpTitle, searchParametersSelector } from '../../../../Serp/selectors';
import SearchTitleComponent from './index';
import Title from '../MetaTitle';
import { getVerticalName } from '~/common/selectors/config';

type State = {
  yourSearch: boolean,
};

type Props = {
  intl: IntlShape,
  verticalName: string,
  categoryName: string,
  serpTitle: string,
  searchParameters: Object,
  customStyles: ?Object,
};

type MapStateToProps = {
  verticalName: string,
  categoryName: ?string,
  serpTitle: ?string,
  searchParameters: Object,
};

class SearchTitle extends React.Component<Props, State> {
  state = {
    yourSearch: !this.props.serpTitle && this.props.verticalName === 'homes',
  };

  render() {
    const {
      intl,
      verticalName,
      categoryName,
      serpTitle,
      searchParameters,
      customStyles,
    } = this.props;

    const h1Title = new Title(intl, verticalName, categoryName, serpTitle, searchParameters);

    return (
      <SearchTitleComponent
        intl={intl}
        title={h1Title.getTitle()}
        yourSearch={this.state.yourSearch}
        customStyles={customStyles}
      />
    );
  }
}

function mapStateToProps(state: Object, { intl }: Props): MapStateToProps {
  return {
    verticalName: getVerticalName(state),
    categoryName: getTypeName(state, intl),
    serpTitle: getSerpTitle(state),
    searchParameters: searchParametersSelector(state),
  };
}

const SearchTitleContainer = compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(SearchTitle);

SearchTitleContainer.displayName = 'SearchTitleContainer';

export default SearchTitleContainer;



// WEBPACK FOOTER //
// ./app/components/shared/Titles/SearchTitle/container.js